import type { DsdkEventName } from './DoceboCoursePlayer.types';
import { DOCEBO_COURSE_PLAYER_DSDK_EVENT_NAMES } from './DoceboCoursePlayer.types';

export type DoceboCoursePlayerDsdkBridgeListener = (
    eventName: DsdkEventName,
    emitterIdOrPayload: unknown,
    payload?: unknown
) => void;

const listeners = new Set<DoceboCoursePlayerDsdkBridgeListener>();

const perEventWrappers: Array<{
    name: DsdkEventName;
    fn: (emitterIdOrPayload: unknown, payload?: unknown) => void;
}> = [];

let installed = false;

const dispatch = (eventName: DsdkEventName, emitterIdOrPayload: unknown, payload?: unknown) => {
    for (const listener of listeners) {
        listener(eventName, emitterIdOrPayload, payload);
    }
};

export function subscribeDoceboCoursePlayerDsdk(listener: DoceboCoursePlayerDsdkBridgeListener): () => void {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}

/**
 * Registers each DSDK event exactly once for the lifetime of the page.
 * Avoids stacking `eventManager.on` calls on every player remount (Docebo can miss `course_loaded`
 * or behave inconsistently when many duplicate handlers exist).
 */
export function ensureDoceboCoursePlayerDsdkBridge(): boolean {
    if (installed) return true;
    if (typeof DSDK === 'undefined' || !DSDK.getEventManager) return false;

    const eventManager = DSDK.getEventManager();
    for (const name of DOCEBO_COURSE_PLAYER_DSDK_EVENT_NAMES) {
        const fn = (emitterIdOrPayload: unknown, payload?: unknown) => dispatch(name, emitterIdOrPayload, payload);
        eventManager.on(name, fn);
        perEventWrappers.push({ name, fn });
    }

    installed = true;
    return true;
}
